import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import GrainOverlay from './components/GrainOverlay';
import Home from './pages/Home';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import Oath from './pages/Oath';

function App() {
  const location = useLocation();

  return (
    <>
      <GrainOverlay />
      <Navigation />
      <AnimatePresence mode="wait">
        <Routes location={location} key={location.pathname}>
          <Route path="/" element={<Home />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/oath" element={<Oath />} />
        </Routes>
      </AnimatePresence>
      <Footer />
    </>
  );
}

export default App;
